export default __webpack_public_path__ + "static/montserrat-v15-latin-900italic-4454c775e48152c1a72510ceed3603e2.woff2";